
export class ExpertiseAlertPage {

    constructor() {

        //document.ready
        $(() => {
            $("#expertiseAlertModal").modal('show');
        });

    }
}
